import { render, staticRenderFns } from "./StoreInformationForm.vue?vue&type=template&id=66dd21d3&"
import script from "./StoreInformationForm.vue?vue&type=script&lang=js&"
export * from "./StoreInformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports